"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExpressionParser = void 0;
const isArray_js_1 = require("../../../../utils/validation/isArray.js");
const isObject_js_1 = require("../../../../utils/validation/isObject.js");
const index_js_1 = require("../symbols/index.js");
const verbParser_js_1 = require("./verbParser.js");
class UpdateExpressionParser {
    constructor(schema) {
        this.parseUpdate = (parsedValue, currentPath = []) => {
            if (parsedValue === undefined) {
                return;
            }
            if ((0, index_js_1.isSetting)(parsedValue)) {
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = ');
                /**
                 * @debt type "Fix this cast"
                 */
                this.set.appendValidAttributeValue(parsedValue[index_js_1.$SET]);
                return;
            }
            if ((0, index_js_1.isGetting)(parsedValue)) {
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = ');
                this.set.appendValidAttributeValue(parsedValue);
                return;
            }
            if ((0, index_js_1.isRemoval)(parsedValue)) {
                this.remove.beginNewInstruction();
                this.remove.appendValidAttributePath(currentPath);
                return;
            }
            if ((0, index_js_1.isSum)(parsedValue)) {
                /**
                 * @debt type "Fix this cast"
                 */
                const [left, right] = parsedValue[index_js_1.$SUM];
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = ');
                this.set.appendValidAttributeValue(left);
                this.set.appendToExpression(' + ');
                this.set.appendValidAttributeValue(right);
                return;
            }
            if ((0, index_js_1.isSubtraction)(parsedValue)) {
                /**
                 * @debt type "Fix this cast"
                 */
                const [left, right] = parsedValue[index_js_1.$SUBTRACT];
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = ');
                this.set.appendValidAttributeValue(left);
                this.set.appendToExpression(' - ');
                this.set.appendValidAttributeValue(right);
                return;
            }
            if ((0, index_js_1.isAddition)(parsedValue)) {
                this.add.beginNewInstruction();
                this.add.appendValidAttributePath(currentPath);
                this.add.appendToExpression(' ');
                /**
                 * @debt type "Fix this cast"
                 */
                this.add.appendValidAttributeValue(parsedValue[index_js_1.$ADD]);
                return;
            }
            if ((0, index_js_1.isDeletion)(parsedValue)) {
                this.delete.beginNewInstruction();
                this.delete.appendValidAttributePath(currentPath);
                this.delete.appendToExpression(' ');
                /**
                 * @debt type "Fix this cast"
                 */
                this.delete.appendValidAttributeValue(parsedValue[index_js_1.$DELETE]);
                return;
            }
            if ((0, index_js_1.isAppending)(parsedValue)) {
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = list_append(if_not_exists(');
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(', ');
                this.set.appendValidAttributeValue([]);
                this.set.appendToExpression('), ');
                /**
                 * @debt type "Fix this cast"
                 */
                this.set.appendValidAttributeValue(parsedValue[index_js_1.$APPEND]);
                this.set.appendToExpression(')');
                return;
            }
            if ((0, index_js_1.isPrepending)(parsedValue)) {
                this.set.beginNewInstruction();
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(' = list_append(');
                /**
                 * @debt type "Fix this cast"
                 */
                this.set.appendValidAttributeValue(parsedValue[index_js_1.$PREPEND]);
                this.set.appendToExpression(', if_not_exists(');
                this.set.appendValidAttributePath(currentPath);
                this.set.appendToExpression(', ');
                this.set.appendValidAttributeValue([]);
                this.set.appendToExpression('))');
                return;
            }
            if ((0, isObject_js_1.isObject)(parsedValue)) {
                for (const [key, value] of Object.entries(parsedValue)) {
                    this.parseUpdate(value, [...currentPath, key]);
                }
                return;
            }
            if ((0, isArray_js_1.isArray)(parsedValue)) {
                parsedValue.forEach((element, index) => {
                    if (element === undefined) {
                        return;
                    }
                    this.parseUpdate(element, [...currentPath, index]);
                });
                return;
            }
            this.set.beginNewInstruction();
            this.set.appendValidAttributePath(currentPath);
            this.set.appendToExpression(' = ');
            this.set.appendValidAttributeValue(parsedValue);
        };
        this.toCommandOptions = () => {
            let UpdateExpression = '';
            const ExpressionAttributeNames = {};
            const ExpressionAttributeValues = {};
            for (const [verb, parser] of [
                ['SET', this.set],
                ['REMOVE', this.remove],
                ['ADD', this.add],
                ['DELETE', this.delete]
            ]) {
                const verbCommandOptions = parser.toCommandOptions();
                if (verbCommandOptions.UpdateExpression === '') {
                    continue;
                }
                if (UpdateExpression !== '') {
                    UpdateExpression += ' ';
                }
                UpdateExpression += verb;
                UpdateExpression += ' ';
                UpdateExpression += verbCommandOptions.UpdateExpression;
                Object.assign(ExpressionAttributeNames, verbCommandOptions.ExpressionAttributeNames);
                Object.assign(ExpressionAttributeValues, verbCommandOptions.ExpressionAttributeValues);
            }
            return {
                UpdateExpression,
                ExpressionAttributeNames,
                ExpressionAttributeValues
            };
        };
        this.schema = schema;
        this.set = new verbParser_js_1.UpdateExpressionVerbParser(schema, 's');
        this.remove = new verbParser_js_1.UpdateExpressionVerbParser(schema, 'r');
        this.add = new verbParser_js_1.UpdateExpressionVerbParser(schema, 'a');
        this.delete = new verbParser_js_1.UpdateExpressionVerbParser(schema, 'd');
    }
}
exports.UpdateExpressionParser = UpdateExpressionParser;
